import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Notification from '@/components/atoms/Notification';
import { useGuestHierarchyTraining } from './useGuestHierarchyTraining';
import Carrousel from '@/components/atoms/Carrousel';
import { ENV } from '@/utils/env';
import { NotificationContent, StyledLink } from './GuestHierarchyTraining.style';

type GuestHierarchyTrainingProps = {};

const StyledText = ({ id }: { id: string }) => {
    return (
        <FormattedMessage
            id={id}
            values={{
                br: <br />,
                // @ts-expect-error
                b: (chunks) => <strong>{chunks}</strong>,
            }}
        />
    );
};
export const GuestHierarchyTraining: React.FunctionComponent<GuestHierarchyTrainingProps> = () => {
    const { displayNotification, isTrainingOpen, onCloseTraining, onOpenTraining } = useGuestHierarchyTraining();

    return (
        <>
            {displayNotification && (
                <Notification
                    title="notification.guestHierarchy.title"
                    content={
                        <>
                            <NotificationContent>
                                <FormattedMessage id="notification.guestHierarchy.content" />
                            </NotificationContent>
                            <StyledLink onClick={onOpenTraining}>
                                <FormattedMessage id="notification.guestHierarchy.link" />
                            </StyledLink>
                        </>
                    }
                />
            )}
            <Carrousel
                isOpen={isTrainingOpen}
                onHide={onCloseTraining}
                data={[
                    {
                        image: `${ENV.STATIC_URL}/dashboard/images/training/hierarchy/step1.png`,
                        title: 'guestHierarchyTraining.page1.title',
                        description: <StyledText id="guestHierarchyTraining.page1.content" />,
                    },
                    {
                        image: `${ENV.STATIC_URL}/dashboard/images/training/hierarchy/step2.png`,
                        title: 'guestHierarchyTraining.page2.title',
                        description: <StyledText id="guestHierarchyTraining.page2.content" />,
                    },
                    {
                        image: `${ENV.STATIC_URL}/dashboard/images/training/hierarchy/step3.png`,
                        title: 'guestHierarchyTraining.page3.title',
                        description: <StyledText id="guestHierarchyTraining.page3.content" />,
                    },
                    {
                        image: `${ENV.STATIC_URL}/dashboard/images/training/hierarchy/step4.png`,
                        title: 'guestHierarchyTraining.page4.title',
                        description: <StyledText id="guestHierarchyTraining.page4.content" />,
                    },
                    {
                        image: `${ENV.STATIC_URL}/dashboard/images/training/hierarchy/step5.png`,
                        title: 'guestHierarchyTraining.page5.title',
                        description: <StyledText id="guestHierarchyTraining.page5.content" />,
                    },
                ]}
            />
        </>
    );
};
